import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1600"
      height="1066.667"
      version="1.1"
      viewBox="0 0 1600 1066.667"
    >
      <g transform="matrix(1.33333 0 0 -1.33333 0 1066.667)">
        <g
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          transform="scale(.1)"
        >
          <path fill="none" d="M12000 0H0v8000h12000V0"></path>
          <path
            fill="#FFF"
            d="M9418.04 2492.44H7695.42v915.98l-145.64 18.65v-962.64h117.63v-40.24l-742.77-65.14v1203.69l1387.1-159.2v-630.58l307.63 26.76v596.71l-279.62 32.09v73.07l604.17-83.91v-632.01l271.15 13.56v609.05l-243.15 33.77v47.76l446.12-51.06zm-1750.63 0h-89.63v902.81l89.63-11.48zm672.34 907.89l251.61-28.87v-546.08l-251.61-21.87zm632.17 13.46l215.14-29.88v-558.04l-215.14-10.76zM7798.01 4744.51l1930.56-989.4-102.64-175.3-2929.61 350.28 129.32 199.87-2402.21 1474.32zm1648.03-2252.07v971.29l-502.12 57.47v-75.25l-632.18 87.8v-102.02l-1415.11 162.41V2328.49l798.79 70.05v65.89h1502.8L6443.23 2207.9v1797.78L4000.02 5514.37l-.34 197.87 332.22-84.64 2454.66-1506.51-138.13-213.48 2983.28-356.69 9.11-1.09 126.88 216.68-1958.32 1003.64-1.41.72-3465.04 882.81-372.43 228.58-1807.75-2165.73-7.71-9.24 164.76-186.07 290.25 308.35V2289.53l641.2-.63v1252.72l477.8 29.86V2276.13l723.48 6.58v1347.48l642.19 42.4V2145.75H468.484v-28.01H5122.71v1584.75l-698.18-46.09V2310.47l-667.48-6.08v1296.9l-533.8-33.36V2316.92l-585.2.58v1582.68l-317.61-337.44-128.48 145.09 1784.52 2137.9L4251.41 5677l-279.8 71.29.44-249.56 2443.17-1508.67V2177.18l3030.82 282.21v5.04h2085.46v28.01H9446.04"
          ></path>
        </g>
      </g>
    </svg>
  );
}

export default Icon;
